// src/context/QueueContext.js
import React, { createContext, useContext, useState } from "react";

const QueueContext = createContext();

export function QueueProvider({ children }) {
  const [queue, setQueue] = useState([]);

  const addToQueue = (article) => {
    // avoid duplicates by ID
    setQueue((prev) => {
      if (!prev.find((item) => item.id === article.id)) {
        return [...prev, article];
      }
      return prev;
    });
  };

  return (
    <QueueContext.Provider value={{ queue, addToQueue }}>
      {children}
    </QueueContext.Provider>
  );
}

export function useQueue() {
  return useContext(QueueContext);
}